import type { Page } from "@server/gql/graphql";

export default function getLeafCategories(
  category: Partial<Page> & {
    children?: string[] | undefined;
  },
  tree: Record<
    string,
    Partial<Page> & {
      children?: string[] | undefined;
    }
  >,
): string[] {
  if (!category) {
    return [];
  }

  if (!category.children?.length) {
    if (!category.slug) return [];
    return [category.slug];
  }

  return category.children.reduce(
    (a, b) => [...a, ...getLeafCategories(tree[b], tree)],
    [] as string[],
  );
}
